import { useAuth } from '../../auth/useAuth.ts';

export function PortalPage() {
  const { user } = useAuth();

  return (
    <main className="mx-auto max-w-3xl px-6 py-20">
      <h1 className="font-serif text-4xl font-bold text-phoenix-blue-900">
        Welcome back{user?.email ? `, ${user.email}` : ''}
      </h1>
      <p className="mt-6 text-lg leading-relaxed text-gray-700">
        This is the client portal — a private space that will eventually hold project galleries,
        renovation progress updates, and a portfolio of finished work for each client.
      </p>
      <p className="mt-4 text-gray-500">
        There&apos;s nothing here yet. Check back as the portal grows in a future phase.
      </p>
    </main>
  );
}
